import { useLocation, useNavigate } from 'react-router-dom';

export const useAddParamsAndNavigate = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const addParamsAndNavigate = (
    newParams: { name: string; value: string | null }[],
  ) => {
    const params = new URLSearchParams(location.search);
    newParams.forEach((param) => {
      if (params.has(param.name)) {
        params.delete(param.name);
      }

      if (param.value && param.value !== '') {
        params.append(param.name, param.value);
      }
    });
    navigate({ pathname: location.pathname, search: params.toString() });
  };

  return addParamsAndNavigate;
};
